export default __webpack_public_path__ + "static/media/form-done.43d15203.svg";